import React from "react";
import TapIcon from "../../../services/TapIcon";
import DateService from "../../../services/DateService";
import Card from "../ui/Card";
import Status from '../../../components/ui/Status';
import Loader from "../../../components/ui/Loader/Loader";

const Compliance = ({
  assetComplianceList,
  complianceLoading,
}) => {
  if (complianceLoading) {
    return (
      <Card title="Asset Compliances">
        <div className="text-center py-4">
          <Loader />
        </div>
      </Card>
    );
  }

  if (!assetComplianceList || assetComplianceList.length === 0) {
    return (
      <Card title="Asset Compliances">
        <div className="text-center py-4 text-muted">
          No compliance records found
        </div>
      </Card>
    );
  }

  return (
    <Card title="Asset Compliances">
      {assetComplianceList.map((item, index) => (
        <div
          key={index}
          className="border my-2 my-sm-3"
          style={{
            border: "1px solid #e0e0e0",
            background: "#fff",
            overflow: "hidden"
          }}
        >
          <div
            style={{
              padding: "8px 12px",
              fontWeight: 600,
              borderBottom: "1px solid #e0e0e0",
              background: "#f8f9fa",
              fontSize: "clamp(13px, 1.2vw, 15px)"
            }}
          >
            {item?.name || "-"}
          </div>
          {item.status == null ? <div className="text-center" style={{ padding: "10px 12px" }}>-</div> :
            <div style={{ padding: "10px 12px" }}>
              <div className="d-flex  flex-wrap justify-content-between align-items-sm-center" style={{ gap: "8px", marginBottom: "10px" }}>
                <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: "4px" }}>
                  <span style={{
                    fontWeight: 500,
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    color: "#6c757d",
                    whiteSpace: "nowrap"
                  }}>
                    Due Date:
                  </span>
                  <span style={{
                    marginLeft: "2px",
                    fontWeight: 500,
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    wordBreak: "break-word"
                  }}>
                    {item?.renewal_date
                      ? DateService.dateTimeFormat(item.renewal_date, "DD-MMM-YYYY")
                      : "-"}
                  </span>
                </div>
                <div style={{
                  fontSize: "clamp(11px, 0.9vw, 13px)",
                  flexShrink: 0
                }}>

                  <Status color={item.status_color_code}>
                    {item.status_text || "-"}
                  </Status>
                </div>
              </div>
              {item.remarks && (
                <div className="mb-2 d-flex flex-wrap align-items-start" style={{ gap: "4px" }}>
                  <span style={{
                    fontWeight: 500,
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    color: "#6c757d",
                    whiteSpace: "nowrap"
                  }}>
                    Remarks:
                  </span>
                  <span style={{
                    marginLeft: "2px",
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    wordBreak: "break-word",
                    flex: 1
                  }}>
                    {item.remarks}
                  </span>
                </div>
              )}
              {item.docs && item.docs.length > 0 && (
                <div className="mt-2">
                  <div className="row">
                    {item.docs.map((doc, docIndex) => (
                      <div className="col-sm-6 mb-2" key={docIndex}>
                        <div
                          className="d-flex justify-content-between align-items-center h-100"
                          style={{
                            padding: "8px 10px",
                            background: "#f8f9fa",
                            gap: "8px"
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              wordBreak: "break-word",
                              flex: 1
                            }}
                          >
                            <span className="pe2"><b> {docIndex + 1}.</b> </span>
                            {doc.number && `${doc.number}` || "-"}

                          </span>

                          <span
                            className="text-primary"
                            onClick={() => window.open(doc.path, "_blank")}
                            style={{
                              cursor: "pointer",
                              color: "#3CB5A0",
                              flexShrink: 0
                            }}
                          >
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              )}
            </div>}
        </div>
      ))}
    </Card>
  );
};

export default Compliance;